import React from "react";
import { IoClose } from "react-icons/io5";

const CancelIconButton = ({ onClick, size = "sm", variant = "outlined" }) => {
  const sizeClasses = {
    sm: "w-6 h-6 text-xs",
    md: "w-8 h-8 text-sm",
    lg: "w-10 h-10 text-base",
  };

  const iconSizeClasses = {
    sm: "w-3 h-3",
    md: "w-4 h-4",
    lg: "w-5 h-5",
  };

  // Define base classes
  const baseClasses = `${sizeClasses[size]} rounded-full flex items-center justify-center transition-all duration-200 focus:outline-none focus:ring-2`;

  // Get variant-specific classes
  const getVariantClasses = () => {
    switch (variant) {
      case "outlined":
        return "text-red-600 border border-red-600 hover:bg-red-50 hover:border-red-700 focus:ring-red-300";
      case "redOutlined":
        return "text-red-600 border border-red-600 hover:bg-red-50 hover:border-red-700 focus:ring-red-300";
      case "subtle":
        return "text-gray-400 hover:bg-gray-100 hover:text-gray-600 focus:ring-gray-300";
      case "filled":
        return "text-white bg-gray-500 hover:bg-gray-600 focus:ring-gray-300";
      case "redFilled":
        return "text-white bg-red-600 hover:bg-red-700 focus:ring-red-300";
      default:
        return "text-red-600 border border-red-600 hover:bg-red-50 hover:border-red-700 focus:ring-red-300";
    }
  };

  return (
    <button
      type="button"
      className={`${baseClasses} ${getVariantClasses()}`}
      onClick={onClick}
      aria-label="Close modal"
    >
      <IoClose className={iconSizeClasses[size]} />
    </button>
  );
};

export default CancelIconButton;
